import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NewspaperIcon(props: IconProps) {
    return <Icon {...props} iconKey={"newspaper"}/>
}
